import { useMemo, useState } from "react"
import {
	Alert,
	Box,
	List,
	ListItemButton,
	ListItemText,
	Popover,
	Stack,
	TextField,
	Typography
} from "@mui/material"
import { TextMatch } from "shared/text"
import { useListDpcDisease } from "interface/dpc"
import { DiseaseResult } from "interface/dpc/types"

type FindDiseasePopoverProps = {
	anchorEl: HTMLButtonElement
	onSelectMdcCode: (mdcCode: string) => void
	onClose: () => void
}
export const FindDiseasePopover = ({
	anchorEl,
	onSelectMdcCode,
	onClose
}: FindDiseasePopoverProps) => {
  const [searchDpcWord, setSearchDpcWord] = useState('')

  const diseaseList = useListDpcDisease('all')
  const groupDiseaseList = useMemo(
    () =>
      diseaseList.data?.list.reduce(
        (acc, item) => {
          const findMdc = acc.find(mdc => mdc.mdcName === item.mdcName)
          if (findMdc) {
            findMdc.dpcList.push(item)
            return acc
          }
          acc.push({
            mdcName: item.mdcName,
            mdcCode: item.dpcCode.substring(0, 2),
            dpcList: [{ ...item }],
          })
          return acc
        },
        [] as {
          mdcName: string
          mdcCode: string
          dpcList: DiseaseResult[]
        }[]
      ),

    [diseaseList]
  )
	const searchDpcResult = useMemo(
		() => {
			const textMatch = new TextMatch(searchDpcWord)
			const searchResult = groupDiseaseList
				?.filter(mdc =>
					textMatch.match(mdc.mdcName) ||
					mdc.dpcList.some((dpc) => textMatch.match(dpc.diseaseName))
				)
				.map((mdcDpc) => {
					const matchDpc = mdcDpc.dpcList.filter((dpc) =>
						textMatch.match(dpc.diseaseName)
					)
					return {
						...mdcDpc,
						dpcList: matchDpc,
					}
				})
			return searchResult
		},
		[groupDiseaseList, searchDpcWord]
	)
	return (
		<Popover
			open={true}
			anchorEl={anchorEl}
			onClose={onClose}
		>
			<Stack maxHeight="70vh" overflow="hidden">
				<Box padding={1}>
					<TextField
						size="small"
						value={searchDpcWord}
						fullWidth
						autoFocus
						onChange={(e) => setSearchDpcWord(e.target.value)}
					/>
				</Box>

				<Box overflow="auto" height="100%" boxSizing="border-box">
					{searchDpcWord === '' ? (
						<Box paddingX={1} paddingBottom={1}>
							<Alert severity="info">キーワードを入力してください</Alert>
						</Box>
					) : searchDpcResult ? (
						searchDpcResult?.length === 0 ? (
							<Box paddingX={1} paddingBottom={1}>
								<Alert severity="warning">一致する疾患はありませんでした</Alert>
							</Box>
						) : (
							<List disablePadding>
								{searchDpcResult?.map((result) => (
									<ListItemButton
										key={`mdc-${result.mdcCode}`}
										onClick={() => onSelectMdcCode(result.mdcCode)}
									>
										<ListItemText
											primary={
												<Typography variant="body1">{result.mdcName}</Typography>
											}
											secondary={result.dpcList.map((dpc, index) => (
												<Typography key={`${dpc.dpcCode}-${index}`} variant="body2">
													{dpc.diseaseName}
												</Typography>
											))}
										/>
									</ListItemButton>
								))}
							</List>
						)
					) : (
						<></>
					)}
				</Box>
			</Stack>
		</Popover>
	)
}